import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {StyledInvoicePreviewWithIcon} from './StyledInvoicePreviewWithIcon';
import ImagePreviewTooltip from '../../TransactionsPage/ImagePreviewTooltip';
import useInvoiceAttachmentPreview from '../../../../hooks/useInvoiceAttachmentPreview';
import {DocumentApprovedIcon} from '../../../../icons';

const InvoicePreviewWithIcon = ({
  icon,
  invoiceId,
  variant = 'backend',
  ...rest
}) => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  const {
    showPreview,
    tooltipContent
  } = useInvoiceAttachmentPreview({variant, handleChangeFullscreen: setIsFullscreen});
  const [isOpen, setIsOpen] = useState(false);

  return (
    <ImagePreviewTooltip
      classNames={{root: 'image-preview-tooltip-overlay single unset-tooltip-width'}}
      title={tooltipContent}
      open={isOpen}
      onOpenChange={(open) => setIsOpen(open)}
      trigger={isFullscreen ? 'click' : 'hover'}
    >
      <StyledInvoicePreviewWithIcon
        {...rest}
        onMouseEnter={() => showPreview(invoiceId)}
      >
        {icon || <DocumentApprovedIcon />}
      </StyledInvoicePreviewWithIcon>
    </ImagePreviewTooltip>
  );
}

InvoicePreviewWithIcon.propTypes = {
  invoiceId: PropTypes.string,
  variant: PropTypes.oneOf(['accounting', 'backend']),
}

export default InvoicePreviewWithIcon;
